export default "__VITE_ASSET__zy1gfBoy__"